/* ============================================================
   SOLENNE — newsletter popup (built new). Self-contained.
   Delay/scroll trigger, localStorage frequency cap (try/catch), accessible
   dialog (Esc + focus), reduced motion (not auto-shown), suppressed after
   signup.
   ============================================================ */
(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STORE_DISMISS = 'sln-newsletter-dismissed';
  const STORE_SIGNUP = 'sln-newsletter-signed-up';

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  class SlnNewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.days = parseInt(this.dataset.days, 10) || 30;
      this.trigger = this.dataset.trigger;
      this.delay = parseInt(this.dataset.delay, 10) || 8000;
      this.scroll = parseInt(this.dataset.scroll, 10) || 60;
      this._lastFocus = document.activeElement;

      // Show the success confirmation once after signup, then stay suppressed.
      if (this.dataset.success === 'true') {
        storageSet(STORE_SIGNUP, '1');
        this.hidden = false;
        return;
      }

      if (storageGet(STORE_SIGNUP) === '1') return;
      const dismissed = storageGet(STORE_DISMISS);
      if (dismissed && (Date.now() - parseInt(dismissed, 10)) < this.days * 86400000) return;

      this.closeButton = this.querySelector('[data-sln-popup-close]');
      this.overlay = this.querySelector('[data-sln-popup-overlay]');
      this.form = this.querySelector('form');

      if (this.closeButton) this.closeButton.addEventListener('click', () => this.close(true));
      if (this.overlay) this.overlay.addEventListener('click', () => this.close(true));
      if (this.form) this.form.addEventListener('submit', () => storageSet(STORE_SIGNUP, '1'));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close(true);
      });

      if (this.trigger === 'delay') {
        setTimeout(() => this.open(), this.delay);
      } else if (this.trigger === 'scroll') {
        this._onScroll = () => {
          const scrolled = ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100;
          if (scrolled >= this.scroll) {
            this.open();
            window.removeEventListener('scroll', this._onScroll);
          }
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
      }
    }

    open() {
      if (reducedMotion) return; // do not auto-show with reduced motion
      this.hidden = false;
      const focusable = this.querySelector('input, button, [href]');
      if (focusable) focusable.focus();
      document.body.style.overflow = 'hidden';
    }

    close(record) {
      this.hidden = true;
      document.body.style.overflow = '';
      if (record) storageSet(STORE_DISMISS, String(Date.now()));
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
    }
  }

  customElements.define('sln-newsletter-popup', SlnNewsletterPopup);
})();
